export default __webpack_public_path__ + "static/media/committed.09b10ffa.svg";